import React from 'react';
import { Popconfirm, Space } from 'antd';
import AppButton from '../../../../components/common/AppButton';
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  SendOutlined,
  UndoOutlined,
} from '@ant-design/icons';
import { useLeaveStore } from '../../../../config/stores';
import { useSelector } from 'react-redux';
import {
  LEAVE_WORKFLOW,
  canModifyLeave,
  isLeaveApproved,
  isLeaveChecked,
  normalizeLeaveStatus,
} from '../../../../components/administration/leave/LeaveApplicationStatus';

const LeaveActionButtons = ({ application, onActionClick, onEdit, onDelete }) => {
  const leaveStore = useLeaveStore();
  const { data: currentUserInfo } = useSelector(
    (state) => state.usersState.currentUserInfo
  );
  const status = normalizeLeaveStatus(application?.status);
  const isOwner = !!application?.applicant_id && application.applicant_id === currentUserInfo?.id;

  const isPending = status === LEAVE_WORKFLOW.pending;
  const isSubmitted = status === LEAVE_WORKFLOW.submitted;
  const isChecked = isLeaveChecked(status);
  const isApproved = isLeaveApproved(status);
  const isReviewer = !isOwner;

  return (
    <Space wrap>
      {isPending && isOwner && (
        <AppButton
          type="primary"
          onClick={() => onActionClick('submit')}
          loading={leaveStore.submittingToSupervisor}
          loadingText="Submitting..."
          text="Submit"
          iconBefore={<SendOutlined />}
        />
      )}
      {isReviewer && isSubmitted && (
        <AppButton
          type="default"
          onClick={() => onActionClick('check')}
          loading={leaveStore.checkingLeaveApplication}
          loadingText="Checking..."
          text="Check"
          iconBefore={<CheckOutlined />}
        />
      )}
      {isReviewer && isChecked && (
        <AppButton
          type="primary"
          onClick={() => onActionClick('approve')}
          loading={leaveStore.approvingLeaveApplication}
          loadingText="Approving..."
          text="Approve"
          iconBefore={<CheckOutlined />}
        />
      )}
      {isReviewer && (isSubmitted || isChecked) && (
        <AppButton
          danger
          type="primary"
          onClick={() => onActionClick('reject')}
          loading={leaveStore.rejectingLeaveApplication}
          loadingText="Rejecting..."
          text="Reject"
          iconBefore={<CloseOutlined />}
        />
      )}
      {isReviewer && isApproved && (
        <Popconfirm
          okText="Yes"
          cancelText="No"
          title="Are you sure you want to undo the approval of this leave application?"
          onConfirm={() => onActionClick('undo-approve')}
        >
          <AppButton
            danger
            type="primary"
            loading={leaveStore.undoApprovingLeaveApplication}
            loadingText="Undoing..."
            text="Undo Approval"
            iconBefore={<UndoOutlined />}
          />
        </Popconfirm>
      )}
      {canModifyLeave(status) && onEdit && (
        <AppButton
          type="default"
          onClick={onEdit}
          text="Edit"
          iconBefore={<EditOutlined />}
        />
      )}
      {canModifyLeave(status) && onDelete && (
        <Popconfirm
          okText="Yes"
          cancelText="No"
          title="Are you sure you want to delete this leave application?"
          onConfirm={onDelete}
        >
          <AppButton
            danger
            type="default"
            loading={leaveStore.deleting}
            loadingText="Deleting..."
            text="Delete"
            iconBefore={<DeleteOutlined />}
          />
        </Popconfirm>
      )}
    </Space>
  );
};

export default LeaveActionButtons;
